import type { TemplateLayoutSummary } from "@/types/template-layout/templateLayout.types";

/**
 * True when the template's name or description contains the search term.
 * @param normalizedSearchTerm - Trimmed, lower-cased term; empty matches every template.
 */
export const templateMatchesSearch = (
  template: Pick<TemplateLayoutSummary, "name" | "description">,
  normalizedSearchTerm: string,
): boolean => {
  if (!normalizedSearchTerm) {
    return true;
  }

  return [template.name, template.description ?? ""].some((value) =>
    value.toLowerCase().includes(normalizedSearchTerm),
  );
};
